import type { PropsWithChildren } from 'react';

import { Drawer } from 'vaul';

import { cn } from '@/shadcn/lib/utils';

export default function Vaul({
  children,
  trigger,
  open,
  setOpen,
  title,
  description
}: PropsWithChildren<{
  trigger?: React.ReactNode;
  open: boolean;
  setOpen?: (open: boolean) => void;
  title?: string;
  description?: React.ReactNode;
}>) {
  return (
    <Drawer.Root direction="right" onOpenChange={setOpen} open={open}>
      {trigger && <Drawer.Trigger>{trigger}</Drawer.Trigger>}
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 z-40 bg-black/20 backdrop-opacity-50" />
        <Drawer.Content
          className="fixed top-1 right-1 bottom-1 z-50 flex w-[calc(100%-8px)] rounded-md p-2 outline-none md:w-[400px] lg:w-[500px]"
          // The gap between the edge of the screen and the drawer is 8px in this case.
          style={
            { '--initial-transform': 'calc(100% + 4px)' } as React.CSSProperties
          }
        >
          <div className="flex h-full w-full flex-col justify-between overflow-hidden rounded-md border border-border bg-card p-2 shadow-xl">
            <section
              className={cn(
                'blur-xs transition-all duration-200 ease-out-cubic',
                open ? 'opacity-100 blur-none' : 'opacity-0'
              )}
            >
              {title && (
                <Drawer.Title className="m-2 font-medium text-base text-card-foreground/80">
                  {title}
                </Drawer.Title>
              )}
              {description && (
                <Drawer.Description className="mx-2 mb-4 text-card-foreground/60 text-sm">
                  {description}
                </Drawer.Description>
              )}
            </section>
            <section className="grow overflow-hidden">{children}</section>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
